/* @flow */
import * as React from 'react';
import { Container } from 'flux/utils';
import CurrentUser from 'auth/CurrentUser';
import Chat from 'entities/Chat';
import LayerTrigger from 'components/LayerTrigger';
import Glyph from 'components/Glyph';
import Button from 'components/ButtonDeprecated';
import PromptActions from 'actions/PromptActions';
import PromptStore from 'stores/PromptStore';
import { PromptNames } from 'constants/PromptConstants';
import Tooltip from 'components/Tooltip';
import { Roles } from 'user/UserConstants';

type Props = {
  chat: ?Chat,
  onSideBarToggle: ?Function,
  sidebar: ?boolean,
  className: ?string,
};

type State = {
  hasDismissedNuxStartNewChatTooltip: boolean,
};

class ConversationHeaderSidebarButton extends React.Component<Props, State> {
  static getStores(): Array<Object> {
    return [PromptStore];
  }

  static calculateState(): State {
    return {
      hasDismissedNuxStartNewChatTooltip: PromptStore.hasDismissed(
        PromptNames.NUX_START_NEW_CHAT_TOOLTIP
      ),
    };
  }

  handleSideBarToggle = () => {
    if (this.shouldShowNuxMoreSidebarTooltip()) {
      PromptActions.recordDismissal(PromptNames.NUX_MORE_SIDEBAR_TOOLTIP);
    }

    if (this.props.onSideBarToggle) {
      this.props.onSideBarToggle();
    }
  };

  shouldShowNuxMoreSidebarTooltip(): boolean {
    return (
      CurrentUser.getUser().getRole() === Roles.teacher &&
      this.state.hasDismissedNuxStartNewChatTooltip &&
      !PromptStore.hasDismissed(PromptNames.NUX_MORE_SIDEBAR_TOOLTIP)
    );
  }

  render() {
    let button = (
      <Button
        size="xxsmall"
        className={this.props.className}
        level={this.props.sidebar ? 'primary' : 'secondary'}
        onClick={this.handleSideBarToggle}
        aria-label="Toggle sidebar">
        <Glyph
          name="ellipses"
          solo
          size="medium"
          data-test-selector="conversation-header-sidebar-button"
        />
      </Button>
    );

    if (this.props.chat && this.shouldShowNuxMoreSidebarTooltip()) {
      const text = this.props.chat.canManageReplies()
        ? 'Click here to disable replies, access chat history, and view user information'
        : 'Click here to access chat history and view user information';

      const tooltip = (
        <Tooltip
          position="left"
          placement="left"
          alignment="middle"
          fixed="true"
          color="pennant"
          type="nux"
          hideOnEscape={false}
          hideOnBlur={false}>
          {text}
        </Tooltip>
      );

      button = (
        <LayerTrigger layer={tooltip} trigger="manual" placement="bottom" defaultLayerShown>
          {button}
        </LayerTrigger>
      );
    }

    return button;
  }
}

export default Container.create(ConversationHeaderSidebarButton);
